import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { GenerateTicketModalComponent } from '../../ticketing/generate-ticket-modal/generate-ticket-modal.component';
import { ApiService } from 'src/app/services/api/api.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';

@Component({
  selector: 'app-vehicle-type-create',
  standalone: false,
  templateUrl: './vehicle-type-create.component.html',
  styleUrl: './vehicle-type-create.component.scss',
})
export class VehicleTypeCreateComponent implements OnInit {
  form: FormGroup;
  approvalForm: FormGroup;
  isDarkMode!: boolean;
  data: any = null;
  lgas: any[] = [];
  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  rememberMe: boolean;
  isDisabled: boolean = false;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GenerateTicketModalComponent>,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    const userDt = localStorage.getItem('USER_DATA');
    if (userDt) {
      this.data = JSON.parse(userDt);
    }

    this.initForm();
    this.getLgas();
  }

  initForm(): void {
    this.form = this.fb.group({
      typeOfVehicle: [null, [Validators.required]],
      ticketAmount: [null, [Validators.required]],
      lga: [null, [Validators.required]],
    });
  }

  getLgas() {
    this.isLoading = true;
    this.apiService
      .get('/utility/all/lga')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.lgas = response.map((lga) => ({
          ...lga,
          formattedName: this.toTitleCase(lga.name.replace(/_/g, ' ')),
        }));
        if (this.data?.permissions.includes('GENERAL_PERMISSION')) {
          this.lgas = this.lgas.map((lga) => ({
            ...lga,
            formattedName: this.toTitleCase(lga.name.replace(/_/g, ' ')),
          }));
        }
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Create Vehicle Type?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.createVehicle();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  createVehicle(): void {
    this.isSubmitting = true;
    this.apiService
      .post('/vehicle-type/create', this.form.value)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
        (response: any) => {
          if (response) {
            this.openSuccessModal('Vehicle Created');
          }

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
